/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".pagination[_ngcontent-%COMP%] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center; }\n\n.general-input[_ngcontent-%COMP%] {\n  width: 89%;\n  padding: .375rem .75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-radius: .25rem;\n  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out; }\n\n.box-parent[_ngcontent-%COMP%] {\n  background: #ffffff;\n  padding: 30px; }"];
export { styles as styles };



// WEBPACK FOOTER //
// /opt/app/src/app/features/saletax/grouped-list/grouped-list.component.scss.shim.ngstyle.js.pre-build-optimizer.js